<template>
  <main class="historytasks-page">
    <TopBar :page-header="$t('historyTasksPage.historicalCMI')" />
    <div class="content">
      <table class="styled-table desktop-table">
        <colgroup>
          <col width="21%">
          <col width="38%">
          <col width="10%">
          <col width="10%">
          <col width="12%">
          <col width="9%">
        </colgroup>
        <thead>
          <tr v-if="Object1Exists()">
            <th>{{ $t('historyTasksPage.TaskNumber') }}</th>
            <th>{{ getObject1Name() }}</th>
            <th>{{ $t('historyTasksPage.Created') }}</th>
            <th>{{ $t('historyTasksPage.Modified') }}</th>
            <th>{{ $t('historyTasksPage.Contact') }}</th>
            <th class="customWidth">
              {{ $t('historyTasksPage.Report') }}
            </th>
          </tr>
          <tr v-else>
            <th>{{ $t('historyTasksPage.TaskNumber') }}</th>
            <th>{{ $t('historyTasksPage.Name') }}</th>
            <th>{{ $t('historyTasksPage.Created') }}</th>
            <th>{{ $t('historyTasksPage.Modified') }}</th>
            <th>{{ $t('historyTasksPage.Contact') }}</th>
            <th class="customWidth">
              {{ $t('historyTasksPage.Report') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="taskdata.length == 0">
            <td colspan="6"
                class="itemEmtypDataTd"
            >
              {{ $t('historyTasksPage.NothingToSee') }}
            </td>
          </tr>
          <tr v-for="item in taskdata"
              v-else
              :key="item.Id"
          >
            <td class="itemTd">
              {{ item.Nr }}
            </td>
            <td class="itemTd">
              {{ item.Location.Name }}
            </td>
            <td class="itemTd">
              {{ item.InspectionCreated }}
            </td>
            <td class="itemTd">
              {{ item.InspectionModified }}
            </td>
            <td class="itemTd">
              {{ item.Contact }}
            </td>
            <td v-if="item.HasReport"
                class="itemTd customWidth"
            >
              <span class="material-icons download"
                    @click="downloadReport(item)"
              >download_for_offline</span>
            </td>
            <td v-else
                class="itemTd customWidth"
            >
              <span class="material-icons download"
                    @click="reportNotReady()"
              >pending</span>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="styled-table mobile-table">
        <colgroup>
          <col width="40%">
          <col width="40%">
          <col width="20%">
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('historyTasksPage.ObjectId') }}</th>
            <th>{{ $t('historyTasksPage.Contact') }}</th>
            <th class="customWidth">
              {{ $t('historyTasksPage.Report') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="taskdata.length == 0">
            <tr>
              <td colspan="3"
                  class="itemEmtypDataTd"
              >
                {{ $t('historyTasksPage.NothingToSee') }}
              </td>
            </tr>
          </template>
          <template v-for="item in taskdata"
                    :key="item.Id"
          >
            <tr>
              <td class="itemTd">
                <span>{{ item.Location.Name }}</span>
                <strong>{{ item.Nr }}</strong>
              </td>
              <td class="itemTd">
                <span>{{ item.Contact }}</span>
                <strong>{{ item.InspectionModified }}</strong>
              </td>
              <td v-if="item.HasReport"
                  class="itemTd customWidth"
              >
                <span class="material-icons download"
                      @click="downloadReport(item)"
                >download_for_offline</span>
              </td>
              <td v-else
                  class="itemTd customWidth"
              >
                <span class="material-icons download"
                      @click="reportNotReady()"
                >pending</span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </main>
</template>

<script setup>
import {
    API_GetFinishedReport
  } from '../apiCalls/api.js';
import TopBar from "../components/TopBar.vue";
import { useToast } from "vue-toastification";
import i18n from '../locales/i18n'
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
  
const toast = useToast();
const store = useStore();

let taskdata = computed(() => store.state.historytasks.taskdata);
let objectnaming = computed(() => store.state.tasks.objectnaming);
console.log(taskdata);
onMounted(async () => {
  store.dispatch("historytasks/getTaskData");
  store.dispatch("tasks/getObjectNaming");
});
function reportNotReady(){
    toast.info( i18n.global.t('historyTasksPage.ReportNotReady') )
}
async function downloadReport(task){
  try{
    const downloadResponse = await API_GetFinishedReport(task.Id);
    //console.log(downloadResponse);
    const byteCharacters = window.atob(downloadResponse.data.Base64Data);
    //const byteCharacters = Buffer.from(downloadResponse.data.Base64Data, 'base64').toString('base64');
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = task.Location.Name;
    link.click()
    URL.revokeObjectURL(link.href)
  }
  catch(e){
    console.log(e);
    toast.error( i18n.global.t('historyTasksPage.ReportDownloadFailed') +"\r\n\r\n"+ e.message )
  }
  
}

function Object1Exists(){
  return objectnaming.value.object1 != null
}

function getObject1Name(){
  if(window.siteConfig?.Object1Name){
    return window.siteConfig.Object1Name[i18n.global.locale]
  }
  return objectnaming.value.object1.single
}

</script>

<style lang="scss" scoped>
.historytasks-page {
  height: 100vh;
  overflow-y: scroll;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  background: #ffffff;
  .content {
    padding: 2rem;
  }
}

.customWidth{
  text-align: center !important;
}
.desktop-table {
  display: table;
}
.mobile-table {
  display: none;
}
.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 25px 0;
  font-family: "Be Vietnam Pro", sans-serif;
  font-size: 12px;
  width: 100%;
}

.styled-table thead tr {
  background-color: #ffffff;
  color: #000000;
  text-align: left;
  border-bottom: 1px solid #777777;
}

.styled-table th {
  padding: 8px 10px;
  text-align: left;
  text-overflow:ellipsis;
  overflow:hidden;
  white-space: nowrap;
  color: #000000;
  font-weight: 600;
}

.itemHeaderTd {
  padding: 12px 10px;
  text-align: left;
  font-weight: bold;
  cursor: pointer;

}
.itemTd {
  padding: 10px;
  text-align: left;
  font-weight: 400;
  transition: padding 0.4s ease;
  word-wrap: break-word;

  > span,
  > strong {
    display: block;
  }

  > strong {
    margin-top: 2px;
    font-weight: 600;
  }

  .download{
    text-align: center;
    cursor: pointer;
  }
}
.itemEmtypDataTd{
    text-align: center;
    padding: 12px 15px;
    font-size: 0.9em;
        font-weight: bold;
}

.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
  background-color: #E6E6E6;

  .expandable {
    overflow: hidden;
    //max-height:0;
    //transition: max-height 1.0s ease;

    height: 0;
    transition: height 1s ease;

    &.is-expanded {
      //max-height: 500px;
      //transition: max-height 1.0s ease;
      height: auto;
      transition: height 1s ease;
    }
  }
}

.styled-table tbody tr:nth-of-type(2n) {
  background-color: #ffffff;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 3px solid var(--primary);
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: var(--sidebar);
}

@media(max-width:769px) {
      .desktop-table {
        display: none;
      }

      .mobile-table {
        display: table;
      }

      .historytasks-page .content{
        padding: 0px;
        min-width: unset;
        width: 100%;
      }

      .styled-table {
        margin: 0;
        font-family: "Be Vietnam Pro", sans-serif;
        font-size: 8px;
      }

      .styled-table thead tr {
        background-color: #ffffff;
        color: #000000;
        border-bottom: 1px solid #777777;
      }

      .styled-table th {
        padding: 7px 4px;
        color: #000000;
        font-weight: 600;
      }

      .itemTd {
        padding: 14px 4px;
        font-weight: 400;
      }
  }
</style>
